// register component(s) with react habitat
import withLazyUnveil from '@src/scripts/hoc/withLazyUnveil';

export default {
	KampagneForm: withLazyUnveil( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "KampagneForm" */
				'./index'
			),
		height: 891,
		mobileHeight: 1064,
	} ),
};
